export default "__VITE_ASSET__DSA8GW5y__"